import { marketingConversationConfigSchema } from "@redotech/redo-marketing-common/conversation-config/marketing-conversation-config-definition";
import { recoverConfigSchema } from "@redotech/redo-model/recover-config";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getRecoverTemplates = {
  name: "getRecoverTemplates" as const,
  input: z.object({ conversationId: zExt.objectId() }),
  output: z.object({
    success: z.boolean(),
    recoverConfig: recoverConfigSchema.optional(),
    conversationConfig: marketingConversationConfigSchema.optional(),
    checkoutUrl: z.string().optional(),
    errorMessage: z.string().optional(),
  }),
};
